export class Billing {
  billingId: Number;
  billingName: String;
  billingPhone: String;
  billingAddress: String;
  isDefault: Boolean = false;

  constructor() {
    this.billingName = '';
    this.billingPhone = '';
    this.billingAddress = '';
  }
}



// WEBPACK FOOTER //
// ./src/app/model/billing/billing.model.ts